<script>
	export let inline = false;
	export let required = false;
</script>

<span class="{inline ? 'inline-block ml-1' : 'block'} my-1 flex-1">
	<slot />
	{#if required}*{/if}
</span>
